import http from '@/http.js'
import store from '@/store/index.js'

export default class OrderService {
  Save(order) {
    store.commit('WorkSymbol', order.symbol)
    store.commit('WorkAccount', order.accountNumber)
    store.commit('WorkDate', order.date)

    return new Promise((resolve, reject) => {
      http.post('/api/order', order)
      .then((response) => {        
        store.commit('AddOrUpdateOrder', response.data)
        resolve(response.data)
      })
      .catch((error) => reject(error))
    })
  }
  Delete(idOrder) {
    return new Promise((resolve, reject) => {
      http.delete(`/api/order/${idOrder}`)
      .then(() => {
        resolve()
      }).catch((e) => {
        reject(e)
      })
    })
  }
	GetOrder(idOrder) {
    return new Promise((resolve, reject) => {
      http.get(`/api/order/${idOrder}`)
      .then((response) => {         
        resolve(response.data) 
      })
      .catch((error) => reject(error))
    })
  }
	GetLast30DaysOrders() {
    store.commit('SetOrders', [])
    return new Promise((resolve, reject) => {
      http.get(`/api/orders/filter/days/30`)
      .then((response) => { 
        store.commit('SetOrders', response.data.data)
        resolve(response.data.data) 
      })
      .catch((error) => reject(error))
    })
  }  
	GetOrders() {
    store.commit('SetOrders', [])
    return new Promise((resolve, reject) => {
      http.get(`/api/orders`)
      .then((response) => { 
        store.commit('SetOrders', response.data)
        resolve(response.data) 
      })
      .catch((error) => reject(error))
    })
  }
	GetOrdersBySymbol(symbol) {
    store.commit('SetOrders', [])
    return new Promise((resolve, reject) => {
      http.get(`/api/orders/${symbol}`)
      .then((response) => { 
        store.commit('SetOrders', response.data)
        resolve(response.data) 
      })
      .catch((error) => reject(error))
    })
  }
  GetOrdersByExpirationDate(date)  {
    store.commit('SetOrders', [])
    return new Promise((resolve, reject) => {
      http.post(`/api/orders/by/expiration`, { date })
      .then((response) => { 
        store.commit('SetOrders', response.data)
        resolve(response.data) 
      })
      .catch((error) => reject(error))
    })    
  }
  FilterOrders(filters) {
    store.commit('SetOrders', [])
    return new Promise((resolve, reject) => {
      http.post('/api/orders/filter', filters)
      .then((response) => {
        store.commit('SetOrders', response.data.orders)
        resolve(response.data)
      })
      .catch((error) => reject(error))
    })
  }
  ImportNote(note, dryRun = false) {
    return new Promise((resolve, reject) => {
      http.post(`/api/orders/import-note?dryRun=${dryRun}`, note)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error))
    })
  }
}
